import axios from "axios";
import React, { useEffect, useState } from "react";
import { localURL } from "./../utils/serverURL";
import { Eye } from "react-ionicons";
import { Link } from "react-router-dom";

const MetaverseTwitterX = (props) => {
  const [tweets, setTweets] = useState([]);
  const [metaverse, setMetaverse] = useState(props.metaverseId);

  useEffect(() => {
    const fetchTweets = async () => {
      try {
        const response = await axios.get(
          `${localURL}metaverses/getTweets/?metaverse=${metaverse}`
        );
        setTweets(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    //fetchTweets();
  }, [metaverse]);

  return (
    <div>
      <div className="nk-widget nk-widget-highlighted mt-4">
        <h4 className="nk-widget-title">
          <span>
            <span className="text-main-1">Twitter</span> X
          </span>
        </h4>
        {/* <div className="nk-widget-content">
          <div className="nk-popup-gallery" data-pswp-uid="2">
            <div className="row sm-gap vertical-gap">
              {screenshots?.map((shot,i) => (
                <div className="col-sm-6" key={i}>
                  <div className="nk-gallery-item-box ">
                    <div  className="border-2 border-cyan-500 w-[150px] h-[100px]">
                      <a href={shot.url} className="nk-gallery-item" data-size="1016x572" className="w-[150px] h-[100px]">
                        <div className="nk-gallery-item-overlay w-[150px] h-[100px]">
                          <Eye color="#fff" />
                        </div>
                        <div className="border-2 border-green-500 w-[150px] h-[100px]"> 
                            <img src={shot.url} alt="" className="w-[150px] h-[100px]"/>
                        </div>
                      </a>

                    </div>
                  
                    <div className="nk-gallery-item-description">
                      <h4>Called Let</h4> Divided thing, land it evening earth
                      winged whose great after. Were grass night. To Air itself
                      saw bring fly fowl. Fly years behold spirit day greater of
                      wherein winged and form. Seed open don't thing midst
                      created dry every greater divided of, be man is. Second
                      Bring stars fourth gathering he hath face morning fill.
                      Living so second darkness. Moveth were male. May creepeth.
                      Be tree fourth.
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 bgDarkGray px-2 py-4 place-content-center place-items-center">
            {tweets.map((tweet, index) => (
              <div
                key={index}
                className="w-[130px] h-[100px] lg:w-[160px] lg:h-[100px] relative"
              >
                {tweet.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaverseTwitterX;
